import { useState } from 'react';
import BoatProForm from './BoatProForm';
import ClubForm from './ClubForm';
import PropTypes from 'prop-types';
import { PRODUCT_BOAT_PRO, PRODUCT_CAPTAINS_CLUB, PRODUCT_OWNERS_CLUB } from './constants';

const SalesforceLead = ({ leadSource, buttonCaption, description, embed, modalTitle }) => {
  const [modalOpen, setModalOpen] = useState(false);

  if (embed !== 'false') {
    return (<>
      {leadSource === PRODUCT_BOAT_PRO && (<BoatProForm description={description} />)}

      {[PRODUCT_CAPTAINS_CLUB, PRODUCT_OWNERS_CLUB].includes(leadSource) && (<ClubForm description={description} product={leadSource} />)}
    </>);
  }

  return (
    <>
      <a
        className="button button--center"
        onClick={() => setModalOpen(true)}>
        {buttonCaption}
      </a>

      {modalOpen && (
        <div className="overlay">
          <div className="boat-pro-form modal modal--contact modal--show">
            <header className="modal__header modal__header--contact">
              <div className="modal__title">{modalTitle}</div>

              <div
                role="button"
                className="boat-pro-form__close-bar-wrapper"
                onClick={() => setModalOpen(false)}
                data-testid="close-button">
                <div className="boat-pro-form__close-bar boat-pro-form__close-bar--left">
                </div>

                <div className="boat-pro-form__close-bar boat-pro-form__close-bar--right">
                </div>
              </div>
            </header>

            {leadSource === PRODUCT_BOAT_PRO && (<BoatProForm description={description} />)}

            {[PRODUCT_CAPTAINS_CLUB, PRODUCT_OWNERS_CLUB].includes(leadSource) && (<ClubForm description={description} product={leadSource} />)}

            {leadSource === PRODUCT_BOAT_PRO && (<div className="boat-pro-form__bottom-logo">
              BOAT
            </div>)}
          </div>
        </div>
      )}
    </>
  );
};

SalesforceLead.propTypes = {
  leadSource: PropTypes.string.isRequired,
  buttonCaption: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  embed: PropTypes.string,
  modalTitle: PropTypes.string.isRequired
};

SalesforceLead.defaultProps = {
  embed: ''
};

export default SalesforceLead;
